import React from 'react';
import PropTypes from 'prop-types';

import './caret.scss';

const Caret = ({ difference, nodata }) => (
  <span className="Caret dato-wrapper">
    {!nodata ? (
      difference == 0 ? (
        <>
          <span className="difference-caret ">-</span>
        </>
      ) : (
        <>
          {difference > 0 ? (
            <span className="difference-caret difference-caret__up" />
          ) : (
            <span className="difference-caret difference-caret__down" />
          )}
          <span className="dato-difference">
            {Math.abs(difference.toFixed(1))}{' '}
          </span>
        </>
      )
    ) : (
      <></>
    )}
  </span>
);
export default Caret;

Caret.propTypes = {
  difference: PropTypes.number.isRequired
};
